"use client";

import React from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
const features = ["On-site consultation", "Energy-efficient designs", "Installation at your convenience", "Extensive quality testing", "Operational training"];
export default function ExpertAcInstallation() {
  return <section id="expertacinstallation" className="bg-background py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          {}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.6,
          ease: "easeOut"
        }} className="order-2 lg:order-1">
            <div className="relative rounded-2xl overflow-hidden border border-border/50 shadow-lg bg-muted">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717132/img/ac_installation_unit_sussex.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717132/img/ac_installation_unit_sussex.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717132/img/ac_installation_unit_sussex.png-wvc-sizes" alt="Modern white air conditioning unit installed on a wall" className="w-full h-auto object-cover aspect-[4/3] md:aspect-auto" loading="lazy" />
            </div>
          </motion.div>

          {}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.6,
          ease: "easeOut",
          delay: 0.2
        }} className="order-1 lg:order-2">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold text-foreground mb-6 tracking-tight">
              Air conditioning Installation Sussex
            </h2>
            
            <p className="text-muted-foreground text-lg mb-8 leading-relaxed">We specialise in expert air conditioning installation across Horsham, Sussex, and Surrey. No matter the size of the installation project, we provide a seamless service from start to finish. As one of the most trusted air conditioning companies in West Sussex catering to both residential and commercial air conditioning clients, with reliable results and a commitment to customer satisfaction.</p>

            <ul className="space-y-4">
              {features.map((feature, i) => <motion.li key={i} data-index={i} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: 0.4 + i * 0.1
            }} className="flex items-center gap-3">
                  <div className="flex-shrink-0 rounded-lg bg-primary/10 p-1 text-primary">
                    <Check className="size-4" strokeWidth={3} />
                  </div>
                  <span className="text-foreground font-medium text-base md:text-lg">
                    {feature}
                  </span>
                </motion.li>)}
            </ul>
          </motion.div>

        </div>
      </div>
    </section>;
}